module.exports = __webpack_public_path__ + "img/concert_deformation.9f59a0e0.jpg";